module.exports = __webpack_public_path__ + "img/log-out.8d4e5f95.svg";